import {useContext} from 'react'
import {DocumentLoadDetailContext} from '../DocumentLoadDetailContext'
import { KTIcon } from '../../../../../../_metronic/helpers'

const DocumentQuickViewModalHeader = () => {
  const {closeDocumentQuickViewModal} = useContext(DocumentLoadDetailContext)

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Visualización Rapida</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeDocumentQuickViewModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {DocumentQuickViewModalHeader}
